import { action } from 'mobx';
import { drawableAcceptBinding } from './drawable.accept.binding';
import { drawableDeleteBinding } from './drawable.delete.binding';
import { imageZoomBinding } from './image.zoom.binding';
import { drawableLineCreateBinding } from './line.create.binding';
import { drawableMarkerCreateBinding, getLabelPoint } from './marker.create.binding';
import { selectionMoveBinding } from './selection.move.binding';

export const IkeDrawBindings = {
	Selection: {
		move: action(selectionMoveBinding),
	},
	Image: {
		zoom: imageZoomBinding,
	},
	Measurement: {
		delete: drawableDeleteBinding,
		accept: drawableAcceptBinding,
		Marker: {
			create: drawableMarkerCreateBinding,
			link: drawableMarkerCreateBinding,
		},
		Line: {
			create: drawableLineCreateBinding,
		},
	},
};

export { getLabelPoint };
